import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-cost-center-list',
  templateUrl: './../../../templates/forms/modals/cheque-book-id.component.html',
})
export class ChequeBookListComponent implements OnInit {

  @Input()
  BANK_DTL_NO;

  @Input()
  modalShow: boolean = true;

  @Input()
  MULTICOMPANY_CHART;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;
  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "ChequeBookListGrid"
  chequeBooksIsList = [];



  searchFields: any[] = ['CHECKBOOK_ID', 'MIN_CKID', 'MAX_CKID', 'COUNTCKID', 'VTYPE_NO'];
  public searchString;
  constructor(private dataService: CommonService,
    public langService: LangService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.checkBookIdCap, field: 'CHECKBOOK_ID', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.minCkID, field: 'MIN_CKID', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.maxCkID, field: 'MAX_CKID', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.countCkId, field: 'COUNTCKID', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.vTypeNo, field: 'VTYPE_NO', sortable: true, resizable: true, hide: false },
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataService.getChkBooksByBankAccNo(this.BANK_DTL_NO)
      .subscribe(arg => { console.log(arg); this.chequeBooksIsList = arg.body });
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }
}


